import type { PlayerProfile } from '@goodtime/engine';

/** The daily bonus streak runs a week; day 7 is the big one. */
export const STREAK_DAYS = 7;

/** What each day of the streak pays. */
export const REWARD_FOR_DAY = (day: number): number => day * 100;

export function claimLocally(profile: PlayerProfile): { reward: number; streak: number } | null {
  const reward = profile.claimDailyBonus();
  return reward === null ? null : { reward, streak: profile.loginStreak };
}

/** Compute what the streak would be if the player claimed right now:
 * mirrors the model's logic so the preview UI matches. Profile exposes
 * {@code previewDailyBonus()} for the reward amount but not the streak;
 * we derive the streak number from the elapsed time. */
export function computePreviewStreak(profile: PlayerProfile): number {
  if (profile.lastLoginEpoch === 0) return 1;
  const now = Math.floor(Date.now() / 1000);
  const elapsed = now - profile.lastLoginEpoch;
  if (elapsed < 86_400 * 2) {
    // Within 48h the streak continues.
    return Math.min(STREAK_DAYS, profile.loginStreak + 1);
  }
  // After 48h it starts again.
  return 1;
}
